import { gql } from "@apollo/client";

export const MUTATION_CREATE_TRUCK = gql`
  mutation CreateTruck(
    $originCity: String
    $originCountry: String
    $originRegion: [String]!
    $originRadius: Int
    $destinationCity: String
    $destinationCountry: String!
    $destinationRegion: [String]
    $destinationRadius: Int
    $trailerTypes: [String]!
    $weight: Int
    $length: Int
    $targetRate: Float
    $timeStart: DateTime!
    $timeEnd: DateTime!
  ) {
    createTruck(
      input: {
        originCity: $originCity
        originCountry: $originCountry
        originRegion: $originRegion
        originRadius: $originRadius
        destinationCity: $destinationCity
        destinationCountry: $destinationCountry
        destinationRegion: $destinationRegion
        destinationRadius: $destinationRadius
        trailerTypes: $trailerTypes
        weight: $weight
        length: $length
        targetRate: $targetRate
        timeEnd: $timeEnd
        timeStart: $timeStart
      }
    ) {
      truck {
        timePosted
        modfied
        id
        originAddress
        originCity
        destinationCity
        destinationAddress
        originIso2
        originCountry
        destinationCountry
        originIso3
        destinationIso2
        destinationIso3
        originZip
        originAreacode
        destinationZip
        destinationAreacode
        originRadius
        destinationRadius
        areaCode
        targetRate
        length
        weight
        timeEnd
        timeStart
        matchDate
        details
        notificationPush
        notificationEmail
        matches
        linehaulDistance
        duration
        isDeleted
        originCoords {
          latitude
          longitude
        }
        destinationCoords {
          latitude
          longitude
        }
        trailerTypes {
          id
          loadtypes
          loadChoiceFull
        }
        originRegion {
          id
          originStates
          destinationStates
        }
        destinationRegion {
          id
          originStates
          destinationStates
        }
        user {
          id
          email
          userType
          contactName
          contactEmail
          address
          city
          state
          country
        }
      }
    }
  }
`;

export const MUTATION_UPDATE_TRUCK = gql`
  mutation UpdateTruck(
    $id: ID!
    $originCity: String
    $originCountry: String
    $originRegion: [String]
    $originRadius: Int
    $destinationCity: String
    $destinationCountry: String
    $destinationRegion: [String]
    $destinationRadius: Int
    $trailerTypes: [String]
    $weight: Int
    $length: Int
    $targetRate: Float
    $timeStart: DateTime
    $timeEnd: DateTime
  ) {
    updateTruck(
      id: $id
      input: {
        originCity: $originCity
        originCountry: $originCountry
        originRegion: $originRegion
        originRadius: $originRadius
        destinationCity: $destinationCity
        destinationCountry: $destinationCountry
        destinationRegion: $destinationRegion
        destinationRadius: $destinationRadius
        trailerTypes: $trailerTypes
        weight: $weight
        length: $length
        targetRate: $targetRate
        timeEnd: $timeEnd
        timeStart: $timeStart
      }
    ) {
      truck {
        timePosted
        modfied
        id
        originAddress
        originCity
        destinationCity
        destinationAddress
        originIso2
        originCountry
        destinationCountry
        originIso3
        destinationIso2
        destinationIso3
        originZip
        originAreacode
        destinationZip
        destinationAreacode
        originRadius
        destinationRadius
        areaCode
        targetRate
        length
        weight
        timeEnd
        timeStart
        matchDate
        details
        notificationPush
        notificationEmail
        matches
        linehaulDistance
        duration
        originCoords {
          latitude
          longitude
        }
        destinationCoords {
          latitude
          longitude
        }
        trailerTypes {
          id
          loadtypes
          loadChoiceFull
        }
        destinationRegion {
          id
          originStates
          destinationStates
        }
        originRegion {
          id
          originStates
          destinationStates
        }
        user {
          id
          email
          userType
          contactName
          contactEmail
          address
          city
          state
          country
          contactPhone
          mc
          dot
        }
        isDeleted
      }
    }
  }
`;

export const MUTATION_UPDATE_TRUCK_AGE = gql`
  mutation UpdateTruck($id: ID!) {
    updateTruck(id: $id, input: {}, refreshPost: true) {
      truck {
        id
        timePosted
      }
    }
  }
`;
